export const CONTACT = {
  phoneDisplay: "+357 99940234",
  tel: "tel:+35799940234",
  whatsapp: "https://wa.me/35799940234",
  website: "https://costataxicy.com",
  email: "costataxicy@gmail.com",
};

// Set href to the real store URL when the app is live. While both are null, the store buttons show a
// "Coming soon" badge and the top "coming soon" banner is shown; both disappear once a link is added.
export const STORES = [
  { id: "google-play", href: null },
  { id: "app-store", href: null },
];
